import { render, staticRenderFns } from "./RetailStock.vue?vue&type=template&id=a952461c"
import script from "./RetailStock.vue?vue&type=script&lang=js"
export * from "./RetailStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports